import { ClippedContent } from 'dyl-components';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

import './index.scss';

const AccountLink = ({ type, name, id, account }) => (
    <div className='AccountLink' disabled>
        <ClippedContent popupContent={name}>
            <Icon className={`AccountLink__icon ${type !== 'household' ? 'fa-solid fa-building' : 'fa-solid fa-house-chimney-blank'}`} />
            <RestrictedView type="link" userPermission={USER_PERMISSIONS.ACCOUNT_VIEW} userRestrict assignmentIds={[(account?.owner_id || 0), (account?.coowner_id || 0)]}>
                <Link to={`/account/${id}`}>{name}</Link>
            </RestrictedView>
        </ClippedContent>
    </div>
);

export default AccountLink;
